import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

type activationOrdersRecalculateDataType = {
  date_from: string;
  successCallback?: Function;
  errorCallback?: Function;
  resultKey: string;
};

export default ({
  date_from,
  successCallback,
  errorCallback,
  resultKey = 'activationOrdersRecalculateResponse',
}: activationOrdersRecalculateDataType) =>
  requestAsync({
    url: endpoints.getActivationOrdersRecalculateUrl(),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getActivationOrdersRecalculateUrl(),
    body: { date_from },
    options: {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
